export default __webpack_public_path__ + "static/media/BrandonGrotesque.0d0868aa.ttf";